export class Loader {

  type = '';
  show = false;

}
